import { getDataFromPackManager } from 'packmanager-communication-lib';
import { createToast } from '../components/Toast/createToast';
import { ApiService } from '../services/Api';

export const fetchBotData = async (packsService: ApiService) => {
  try {
    async function fetchProfileData() {
      return await getDataFromPackManager('packId');
    }
    const packId: string = await fetchProfileData();
    const packBots = (await packsService.get(`/installations/pack/${packId}/authenticated-member`)) as unknown[];

    return { botRef: packBots[0], botList: packBots };
  } catch (error) {
    createToast('failed');
    console.error('Error fetching bot data:', error);
  }
};
